import { Tooltip } from '@mui/material';
import React from 'react';
import { HiOutlineTicket } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { UIExtendedApplication } from 'types';

interface Props {
	application: UIExtendedApplication;
	className?: string;
	// Icon-only round button for small screens
	compact?: boolean;
}

// Opens the support flow pre-filled with this company and position.
const CreateTicketButton = ({ application, className = '', compact = false }: Props) => {
	const navigate = useNavigate();

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		const companyId =
			typeof application.position?.company === 'object' ? application.position.company?._id : application.position?.company;
		const params = new URLSearchParams({
			questionType: 'company',
			modal: 'search',
			batchId: '0',
			...(companyId && { companyId: String(companyId) }),
			...(application.position?._id && { positionId: String(application.position._id) }),
		});
		// applicationId is optional - only pass the application document ID for tracking
		if (application._id) {
			params.set('applicationId', application._id);
		}
		navigate(`/support?${params.toString()}`);
	};

	return (
		<Tooltip
			title="Create support ticket"
			placement="top"
			arrow
			enterDelay={150}
			componentsProps={{
				tooltip: {
					sx: {
						bgcolor: '#111E2C',
						color: '#fff',
						fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
						fontSize: '12.5px',
						fontWeight: 600,
						lineHeight: '18px',
						px: 1.5,
						py: 0.75,
						borderRadius: '10px',
						boxShadow: '0 8px 20px rgba(20,20,60,0.22)',
					},
				},
				arrow: { sx: { color: '#111E2C' } },
			}}
		>
		<button
			type="button"
			onClick={handleClick}
			aria-label="Create ticket"
			className={`inline-flex items-center justify-center border border-[#E3E3EC] bg-white text-[#111E2C] transition-colors hover:bg-[#F4F4F9] dark:border-[#4B5563] dark:bg-[#18222D] dark:text-white ${
				compact ? 'h-9 w-9 rounded-full' : 'gap-1.5 rounded-[10px] px-3 py-1.5 text-[13px] font-[600] whitespace-nowrap'
			} ${className}`}
		>
			<HiOutlineTicket className={compact ? 'h-[18px] w-[18px]' : 'h-4 w-4'} />
			{compact ? null : 'Create ticket'}
		</button>
		</Tooltip>
	);
};

export default CreateTicketButton;
